import styled from 'styled-components';

export const SpaceTop = styled.div<{ $marginTop: boolean }>`
  ${({ $marginTop, theme }) =>
    $marginTop &&
    `
    margin-top: ${theme.spacing(3)}px;
  `}
`;
